import { Field } from 'redux-form';
import { renderInput, renderSwitch } from '../../../form/renderTextField';
import React from 'react';

export const UiBaseInputRedux = props => (
  <Field component={props.type === 'switch' ? renderSwitch : renderInput} {...props} />
);
